// extracted by mini-css-extract-plugin
export default {"deletePolicyButton":"src-hellosign-components-my-settings-purge-document-settings__deletePolicyButton--2UD5X"};